import Button from '../../../../components/form-control/Button';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { Formik } from 'formik';
import Input from '../../../../components/form-control/Input';
import * as Yup from 'yup';
import { useState } from 'react';
import { addSlackWorkspace } from '../../../../api/requests';
import TextArea from '../../../../components/form-control/TextArea';
import SelectMenu from '../../../../components/form-control/SelectMenu';
import { showToast } from '../../../../utils/miscFunctions';

type AddWorkspaceFormProps = {
    name: string;
    description: string,
    token: string,
    active: boolean,
}
const AddWorkspace = ({ onProceed, onClose }: { onProceed: () => void; onClose: () => void }) => {
    const [submitting, setSubmitting] = useState<boolean>(false);

    return (
        <div className="w-full">
            <div className="p-5">
                <Formik
                    initialValues={{
                        name: '',
                        description: '',
                        active: '',
                        token: '',
                    }}
                    validateOnChange={false}
                    validateOnBlur
                    validationSchema={Yup.object({
                        name: Yup.string().trim().required('workspace  name is required.'),
                        active: Yup.string().trim().required('workspace  status is required.'),
                    })}
                    onSubmit={(values) => {
                        setSubmitting(true);
                        const payload: AddWorkspaceFormProps = {
                            ...values,
                            active: values.active === 'Active' ? true : false
                        };

                        addSlackWorkspace(payload)
                            .then((response: any) => {
                                if (response) {
                                    showToast.success(response.message ?? 'Workspace added successfully');
                                    onProceed();
                                }
                            })
                            .catch((error: any) => {
                                showToast.error(error?.description);
                            })
                            .finally(() => setSubmitting(false));
                    }}>
                    {({ values, errors, handleSubmit, handleChange, handleBlur, setFieldValue, touched }) => (
                        <form className="space-y-4" onSubmit={handleSubmit}>
                            <div className="">
                                <div className="grid grid-cols-1  justify-center gap-5">
                                    <Input
                                        name="name"
                                        label="Name"
                                        value={values.name}
                                        type="text"
                                        placeholder="Workspace name"
                                        required
                                        error={touched.name ? errors.name : undefined}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        helperText={touched.name ? errors.name : undefined}
                                    />

                                    <SelectMenu
                                        label="Status"
                                        name="active"
                                        placeholder="Select workspace status"
                                        onChange={(value: string) => {
                                            setFieldValue('active', value);
                                        }}
                                        list={['Active', 'Inactive']}
                                        listSelectedValue={values.active}
                                        onBlur={handleBlur}
                                        required
                                        helperText={touched.active ? errors.active : undefined}
                                        error={touched.active ? errors.active : undefined}
                                    />
                                    <Input
                                        type="text"
                                        name="token"
                                        label="Token"
                                        value={values.token}
                                        placeholder="Workspace token"
                                        required
                                        error={touched.token ? errors.token : undefined}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        helperText={touched.token ? errors.token : undefined}
                                    />
                                    <TextArea
                                        name="description"
                                        label="Description"
                                        value={values.description}
                                        required
                                        placeholder='Workspace description'
                                        error={touched.description ? errors.description : undefined}
                                        onChange={handleChange}
                                        onBlur={handleChange}
                                        helperText={touched.description ? errors.description : undefined}
                                    />
                                </div>
                            </div>

                            <div className="flex justify-end">
                                <Button
                                    type="submit"
                                    label="Submit"
                                    bgColor="primary"
                                    className="w-fit px-6 text-[14px] bg-primary-main hover:bg-primary-main"
                                    loading={submitting}
                                    disabled={submitting}
                                    curved
                                />
                            </div>
                        </form>
                    )}
                </Formik>
            </div>
        </div>
    );
};

export default AddWorkspace;
